export const toHumanReadable = (date: string) =>
  new Date(date).toLocaleString();
